import { z } from "zod";
import { MetaSchema } from "./shared";

export const InvestmentSumSchema = z.object({
  sum: z.string().nullable(),
});

export const ActivePoolSummaryDataSchema = z.object({
  totalIncome: z.number().nullable(),

  totalInvest: InvestmentSumSchema,

  sumOfCampaignInvest: InvestmentSumSchema,

  sumOfCampaignReward: InvestmentSumSchema,

  normalInvest: z.number().nullable(),
});

const UsersInvestmentsActivePoolSummaryResponse = z.object({
  data: ActivePoolSummaryDataSchema,
  meta: MetaSchema.default,
});

export type UsersInvestmentsActivePoolSummaryResponseType = z.infer<
  typeof UsersInvestmentsActivePoolSummaryResponse
>;

export default UsersInvestmentsActivePoolSummaryResponse;
